import { BaseService } from "../../../../shared/services";
import { filterCollection } from "../../offline/db/filter.db";
import { IFilterItemDto } from "../dtos/filter-item";

// eslint-disable-next-line
class FiltersService extends BaseService<IFilterItemDto, Record<string, any>> {
  async get(_: string): Promise<IFilterItemDto> {
    throw new Error("Cant be used");
  }

  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  async list(filter: Record<string, any>): Promise<IFilterItemDto[]> {
    return await filterCollection.find(filter);
  }

  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  async addOrUpdate(data: IFilterItemDto): Promise<any> {
    const { _id, value } = data;

    if (!_id) {
      return; // TODO: throw something;
    }

    const item = await filterCollection.findOne({ _id });
    if (item && item.value === value) {
      return {};
    }

    if (!item) {
      try {
        return await filterCollection.insertOne({ _id, value });
      } catch (insertError) {
        const raceUpdateResult = await filterCollection.updateOne(
          { _id },
          { _id, value },
          { bypassDocumentValidation: true }
        );
        if (raceUpdateResult.matchedCount > 0) {
          return raceUpdateResult;
        }
        throw insertError;
      }
    }

    return filterCollection.updateOne(
      { _id },
      { _id, value },
      { bypassDocumentValidation: true }
    );
  }

  async clear(): Promise<void> {
    const allItems = await filterCollection.find({});
    for (const item of allItems) {
      await filterCollection.deleteOne({ _id: item._id });
    }
  }
}

export const filtersService = new FiltersService();
